import React, { useEffect, useRef } from 'react';
import { useIntersection } from 'react-use';
import { jsx as _jsx } from "react/jsx-runtime";
export const Swimlane = ({
  children,
  onIntersectionChanged,
  rootMargin,
  ...rest
}) => {
  const swimlaneRef = useRef(null);
  const intersection = useIntersection(swimlaneRef, {
    root: null,
    rootMargin: rootMargin ?? '550px',
    threshold: 0
  });
  useEffect(() => {
    if (intersection && onIntersectionChanged) {
      onIntersectionChanged(intersection.isIntersecting);
    }
  }, [intersection, onIntersectionChanged]);
  return /*#__PURE__*/_jsx("div", {
    ref: swimlaneRef,
    ...rest,
    children: children
  });
};